<template>
  <v-container
    ref="container"
    v-resize="resize"
    class="widgetText--text widget pa-0"
    style="position: relative; height: 100%; overflow: hidden">
    <BaseWidgetHeader ref="widgetHeader" label="Utility - dijagrami" @close-parent-widget="close">
      <template #anyButton>
        <v-tooltip bottom>
          <template #activator="{props}">
            <v-btn
              v-bind="props" icon x-small
              color="widgetText" style="margin-bottom: 2px"
              class="ml-2" v-on="on"
              @click="refresh">
              <v-icon dark>
                mdi-refresh
              </v-icon>
            </v-btn>
          </template>

          <span>Refresh</span>
        </v-tooltip>
      </template>
    </BaseWidgetHeader>
    <v-row>
      <v-col cols="12">
        <v-row align="center" justify="center" class="pa-0 ma-0">
          <v-col
            v-for="(tool, id) in tools" :key="id" cols="2"
            class="pa-0 ma-0" align="center" justify="center">
            <BaseTooltip :key="id" bottom>
              <template #activator="{on, attrs}">
                <v-btn
                  v-bind="attrs"
                  height="34" width="34"
                  :color="tool.name === selectedTool ? $vuetify.theme.themes.dark.elements : ''"
                  :style="{
                    color:
                      (tool.name === selectedTool)
                        ? $vuetify.theme.themes.dark.elementsText
                        : 'black'
                  }"
                  x-small elevation="0"
                  v-on="on"
                  @click="
                    createDiagram(tool)
                  ">
                  <v-icon> {{ tool.icon }}</v-icon>
                </v-btn>
              </template>
              {{ tool.name }}
            </BaseTooltip>
          </v-col>
        </v-row>
        <v-row justify="center" align="center">
          <v-col cols="12">
            <v-divider />
          </v-col>
          <v-col cols="11">
            <base-autocomplete
              v-model="selectedTemplate" label="Template" item-text="noText"
              :items="templates" @change="initDiagram(false)" />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <v-divider />
      </v-col>
      <v-col cols="12" class="ma-2">
        <template v-if="imageUrl">
          <v-img
            id="myImage" height="600px" width="350px"
            class="mx-2 pa-0 my-0"
            style="border: solid 1px;" :src="imageUrl" />
        </template>
        <template v-else>
          <v-row align="center" justify="center">
            <v-progress-circular indeterminate />
          </v-row>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from 'axios'
import BaseAutocomplete from '../components/UIElements/BaseAutocomplete.vue'
export default {
  name: 'UtilityDiagram',
  components: { BaseAutocomplete },
  data () {
    return {
      headerHeight: '0px',
      tools: [
        { name: 'dijagram', functionName: 'ForceDirectedDiagramLayout', icon: 'mdi-graph' },
        { name: 'dijagram2', functionName: 'SmartTreeDiagramLayout', icon: 'mdi-graph-outline' },
        { name: 'dijagram3', functionName: 'GridDiagramLayout', icon: 'mdi-graphql' },
        { name: 'dijagram4', functionName: 'CompressionDiagramLayout', icon: 'mdi-grid' },
        { name: 'dijagram5', functionName: 'MainLineTreeDiagramLayout', icon: 'mdi-chart-timeline-variant' },
        { name: 'dijagram6', functionName: 'GeoPositionsDiagramLayout', icon: 'mdi-chart-timeline-variant-shimmer' },
      ],
      selectedTool: '',
      ids: [],
      token: 'T29PV8vb0kNgCx5bcdMNWgABSkLaFktCUHtgvjB92f6Ri2J9UkbCq8OPrYw1slerSdCsGfD7DyTJcgTMTvgKIilh3oX109Q-YFCw1u4DP30TYtI5bmBBcpvs3VtWCyhQkEQSpLVqUX8u-kUFy5fK55lxbXKHpHnN5V5VrM_qJwo.',
      imageUrl: null,
      diagramName: '',
      templates: [],
      selectedTemplate: 'Basic',
    }
  },
  computed: {
    activeTool () {
      return this.$store.getters.getActiveTool
    },
    externalJsResult () {
      return this.$store.getters.getExternalJs?.result
    },
  },
  watch: {
    activeTool (newValue) {
      if (newValue === 'UtilityDiagram') {
        this.resize()
      }
    },
    externalJsResult (newVal) {
      if (newVal?.length > 0) {
        this.selectedTool = ''
        this.selectedTemplate = 'Basic'
        this.imageUrl = ''
        this.initDiagram()
      }
    },
  },
  async created () {
    const template = await axios.get('https://gdigeoportal.rs/server/rest/services/Map/NetworkDiagramServer/templates?f=pjson')
    this.templates = template.data.templates
  },
  methods: {
    refresh () {
      this.$store.dispatch('storeExternalJs', { result: [] })
    },
    async initDiagram (applyDiagram) {
      if (!applyDiagram) {
        this.selectedTool = ''
        this.ids = []
        for (const res of this.externalJsResult) {
          this.ids.push(res.feature.attributes.GLOBALID)
        }
        console.log(this.ids)
        this.ids = this.ids.map(e => '"' + e + '"')
        const bodyFormData = new FormData()
        bodyFormData.append('template', this.selectedTemplate)
        bodyFormData.append('token', this.token)
        bodyFormData.append('initialFeatures', '[' + this.ids + ']')
        bodyFormData.append('f', 'json')
        const response = await axios.post('https://gdigeoportal.rs/server/rest/services/Map/NetworkDiagramServer/createDiagramFromFeatures', bodyFormData)
        this.diagramName = response.data.diagramInfo.name
      }
      this.imageUrl = ''
      if (this.diagramName) {
        const params = {
          f: 'json',
          token: this.token,
        }
        const diagram = await axios.get('https://gdigeoportal.rs/server/rest/services/Map/NetworkDiagramServer/diagrams/' + this.diagramName + '/map', { params })
        if (diagram.data) {
          this.imageUrl = 'https://gdigeoportal.rs/server/rest/services/Map/NetworkDiagramServer/diagrams/' + this.diagramName + '/map/export?bbox=' + diagram.data.fullExtent.xmin + ',' + diagram.data.fullExtent.ymin + ',' + diagram.data.fullExtent.xmax + ',' + diagram.data.fullExtent.ymax +
            '&bboxSR=' + diagram.data.spatialReference.wkid + '&' +
            'imageSR=' + diagram.data.spatialReference.wkid + '&' +
            'size=' + 350 + ',' + 600 + '&' +
            'dpi=' + 120 + '&' +
            'format=png32&' +
            'transparent=' + true + '&' +
            'layers=show:' + diagram.data.layers[0].id + '&' +
            'f=image&' +
            'token=' + this.token + '&' +
            'prevent=' + Math.random()

          /* const params = {
            bbox: diagram.data.fullExtent.xmin + ',' + diagram.data.fullExtent.ymin + ',' + diagram.data.fullExtent.xmax + ',' + diagram.data.fullExtent.ymax,
            bboxSR: diagram.data.spatialReference.wkid,
            imageSR: diagram.data.spatialReference.wkid,
            size: '350, 600',
            dpi: 120,
            format: 'png32',
            transparent: true,
            layers: 'show:' + diagram.data.layers[0].id,
            f: 'image',
            token: this.token,
          }
          const res = await axios.get('https://gdigeoportal.rs/server/rest/services/Water_Distribution_Editor/NetworkDiagramServer/diagrams/' + this.diagramName + '/map/export', { params })
          console.log(res) */
        }
      }
    },
    async createDiagram (tool) {
      this.selectedTool = tool.name
      const bodyFormData = new FormData()
      bodyFormData.append('layoutName', tool.functionName)
      bodyFormData.append('token', this.token)
      bodyFormData.append('f', 'json')

      const response = await axios.post('https://gdigeoportal.rs/server/rest/services/Map/NetworkDiagramServer/diagrams/' + this.diagramName + '/applyLayout', bodyFormData)
      this.initDiagram(true)
      console.log(response)
    },

    close () {
      this.$store.dispatch('unSetActiveTool')
    },
    resize () {
      if (this.activeTool === 'UtilityDiagram') {
        const containerH = this.$refs.container.clientHeight
        const titleH = this.$refs.widgetHeader.$refs.title.clientHeight
        const dividerH = this.$refs.widgetHeader.$refs.divider.clientHeight
        const tabsH = 30
        const layersH = this.layers ? this.$refs.layers.clientHeight : 0
        const footerH = this.$refs.footerDiv?.clientHeight ? this.$refs.footerDiv?.clientHeight : 0
        this.footerHeight = footerH + 'px'
        const h = containerH - titleH - dividerH - layersH - footerH - tabsH
        this.computedHeight = h + 'px'
      }
    },

  },
}
</script>
<style scoped>

.hover:hover {
  cursor: pointer;
}
</style>
<style scoped>
.absolutePosition {
    position: absolute;
    display: block;
    z-index: 100;
}
.column-name {
  font-weight: 500;
  font-size: 14px;
}
</style>
